let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("7XMUP")]).then(() => parcelRequire('8VQU1'));